module.exports = __webpack_public_path__ + "static/media/link.fb1da713.svg";